export const NOTIFICATION_KEYS = {
  R_ADDON: 'R-ADDON',
  DISCOUNT_CODE_REMOVE: 'DISCOUNT_CODE_REMOVE',
  R_MEAL_TYPE_ITEM: 'R-MEAL-TYPE-ITEM',
  R_MONEYBOX_DISABLED_FOR_DISCOUNT_CODE:
    'R-MONEYBOX-DISABLED-FOR-DISCOUNT-CODE',
};
